import React from 'react';
import {FormControl, Select, MenuItem, Paper} from '@mui/material';
import {SelectPopupIcon} from 'assets/icons';

import styles from './CampaignsToolbar.module.scss';

interface Props {
  isActive: boolean;
  setIsActive: (v: boolean) => void;
}

export const CampaignsToolbar = ({isActive, setIsActive}: Props) => {
  return (
    <div className={styles.tableFiltersTop}>
      <div className={styles.tableAutocompleteFilters}>
        <FormControl size="small" sx={{width: '200px'}}>
          <Select
            value={isActive ? 'true' : 'false'}
            onChange={(e) => setIsActive(e.target.value === 'true')}
            IconComponent={(props) => <SelectPopupIcon {...props} />}
            MenuProps={{
              PaperProps: {
                component: Paper,
                sx: {
                  borderRadius: '12px',
                  boxShadow: 'var(--shadow-card)',
                  mt: '8px',
                },
              },
              MenuListProps: {
                disablePadding: true,
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
            sx={{
              fontSize: '14px',
              color: 'var(--text-primary)',
              background: 'var(--bg-surface)',
              borderRadius: '12px',
              height: '40px',
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--border-strong)',
                borderRadius: '12px',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--border-strong)',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--primary)',
              },
            }}
          >
            <MenuItem value="true" className={styles.dropDownItem}>
              Active
            </MenuItem>
            <MenuItem value="false" className={styles.dropDownItem}>
              Inactive
            </MenuItem>
          </Select>
        </FormControl>
      </div>
    </div>
  );
};
